var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2886 27.6108C15.433 31.4897 6.68297 29.0541 2.80411 22.2887C-0.984551 15.433 1.36081 6.683 8.21648 2.80413C15.0722 -1.07474 23.7319 1.36083 27.6108 8.2165C31.4897 15.0722 29.0541 23.732 22.2886 27.6108ZM9.02834 4.24743C2.89431 7.67526 0.729366 15.433 4.24741 21.4768C7.67524 27.5206 15.433 29.6856 21.4768 26.2577C27.5206 22.8299 29.6856 15.0722 26.2577 9.02836C22.8299 2.89434 15.0722 0.729388 9.02834 4.24743Z",
    fill: "#7B7C7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7293 33.0232C35.2783 33.4742 34.6469 33.4742 34.1958 33.1134L26.7087 26.8892C26.2577 26.5283 26.1675 25.8067 26.5283 25.3557C26.8891 24.9046 27.6108 24.8144 28.0618 25.1753L35.5489 31.3995C36 31.8505 36.0902 32.5722 35.7293 33.0232Z",
    fill: "#7B7C7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.a7413eccee960b5391d3acd93c219804.svg";
export { ForwardRef as ReactComponent };